export default __webpack_public_path__ + "static/media/0x98ea609569bd25119707451ef982b90e3eb719cd.db2cf67e.svg";